<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help Text"
      [formField]="configForm.helpText" />

    <lib-signal-date-field
      label="Default Start Date"
      hint="Automatically filled when the form opens. Respondents can change it."
      [formField]="configForm.defaultStartDate"
      dateFormat="mmddyyyy" />
    <lib-signal-date-field
      label="Default End Date"
      hint="Automatically filled when the form opens. Respondents can change it."
      [formField]="configForm.defaultEndDate"
      dateFormat="mmddyyyy" />
    <lib-signal-date-field
      label="Minimum Date"
      [formField]="configForm.minDate"
      dateFormat="mmddyyyy" />
    <lib-signal-date-field
      label="Maximum Date"
      [formField]="configForm.maxDate"
      dateFormat="mmddyyyy" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Date Restrictions
    </h3>
    <lib-signal-checkbox
      label="Allow Only Past Dates"
      [formField]="configForm.allowOnlyPast" />
    <lib-signal-checkbox
      label="Allow Only Future Dates"
      [formField]="configForm.allowOnlyFuture" />
    <lib-signal-checkbox
      label="Required"
      [formField]="configForm.required" />
  </section>
</form>
